import { gql } from '@apollo/client/core';

export const CREATE_FOLLOW = gql`
  mutation CreateFollow($input: CreateFollowInput!) {
    createFollow(input: $input) {
      response
    }
  }
`;
